import { enhancedLocalStorage, enhancedSessionStorage } from '@/scripts/storage/browser';

export const userStorage = enhancedLocalStorage.getModule('user');
export const userSessionStorage = enhancedSessionStorage.getModule('user');
export const devStorage = enhancedLocalStorage.getModule('dev');
export const STLocalStorage = enhancedLocalStorage.getModule('serverTime');
export const updateInfoStorage = enhancedLocalStorage.getModule('updateInfo');
